























































































































import { Component, Vue } from 'vue-property-decorator'
import { userType } from '@/app/model/store/domain/const'

@Component
export default class AccountSearch extends Vue {
  private account: number = this.$store.state.accountState.choiceAccountType
  private accountType: {[key: string]: string|number}[] = [
    { label: '', value: userType.USER_TYPE_ALL },
    { label: '圃場管理者', value: userType.USER_TYPE_FARM_ADMIN },
    { label: '圃場作業者', value: userType.USER_TYPE_FARM_WORKER }
  ]
  private search: string = this.$store.state.accountState.searchText
  public requesting: boolean = false

  private doAccountSearch () {
    /* ユーザータイプで絞り込み */
    this.$store.commit('accountState/setChoiceAccountType', this.account)

    /* キーワード検索 */
    this.$store.commit('accountState/setSearchText', this.search)

    /* ソートは初期値に戻す */
    this.$store.commit('accountState/setOrderNum', 1)
    this.$store.commit('accountState/setSort', 'asc')

    this.$emit('search-list')
  }

  private doClear () {
    /* storeをリセット */
    this.$store.commit('accountState/setChoiceAccountType', userType.USER_TYPE_ALL)
    this.$store.commit('accountState/setSearchText', '')
    this.$store.commit('accountState/setOrderNum', 1)
    this.$store.commit('accountState/setSort', 'asc')
    this.account = userType.USER_TYPE_ALL
    this.search = ''
    this.$emit('reset-list')
  }
}
